<template>
  <div id="wx">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
  import systemRegister from '@/components/systemRegister'
export default {
  name: 'wx',
  components: {
    'systemRegister': systemRegister
  }
}
</script>

<style>
#wx {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 10px;
  }

.header {
  background-color: #409EFF;
  color: #fff;
  line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/Wx.vue